import styled from "styled-components";

export const HeaderDiv = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 21px;
  p {
    font-size: 18px;
  }
  svg {
    width: 20px;
    height: 20px;
    cursor: pointer;
    margin-left: 8px;
    flex-shrink: 0;
  }
  span {
    svg {
      /* margin-left: 5px; */
      height: 11px;
    }
  }
  /* span {
    color: #413f62;
    font-size: 12px;
    max-width: 159px;
    width: 100%;
    text-align: right;
    position: relative;
    margin-left: 5px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: end;
    justify-content: flex-end;
 
  } */
`;

export const BalanceContainer = styled.div`
    color: #413f62;
    font-size: 12px;
    max-width: 159px;
    width: 100%;
    text-align: right;
    position: relative;
    margin-left: 5px;
    display: flex;
    -webkit-box-align: center;
    align-items: center;
    -webkit-box-pack: end;
    justify-content: flex-end;
    flex-wrap: wrap;
    `
export const Balance = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 5px;
`